export const LOCALE_PREFIX = 'scenes.Gnosus.scenes.Report.components.Workspace.components.Blocks.CompanyAsCreditor' // eslint-disable-line

export const COMPANY_AS_CREDITOR_LOAD_TABLE_DATA = 'COMPANY_AS_CREDITOR_LOAD_TABLE_DATA'
export const COMPANY_AS_CREDITOR_TABLE_CHANGE = 'COMPANY_AS_CREDITOR_TABLE_CHANGE'
export const COMPANY_AS_CREDITOR_LOAD_TABLE_DATA_REQUEST = (tableId) => `${tableId.toUpperCase()}_REQUEST`
export const COMPANY_AS_CREDITOR_TABLE_LOADING_TRUE = 'COMPANY_AS_CREDITOR_TABLE_LOADING_TRUE'
export const COMPANY_AS_CREDITOR_TABLE_LOADING_FALSE = 'COMPANY_AS_CREDITOR_TABLE_LOADING_FALSE'
export const COMPANY_AS_CREDITOR_TABLE_DATA_RECEIVED = 'COMPANY_AS_CREDITOR_TABLE_DATA_RECEIVED'
